import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Spin,
  Tag,
  Typography,
  message,
  notification,
} from "antd";
import { axios, getToken, URL_API } from "../../../../../utils";
import { resCatch } from "../../../../util/helper";
import SelectPartner from "./selectPartner";
import { data } from "jquery";

const { Option } = Select;

const ReserveModal = ({ visible, onCancel, onSuccess }) => {
  const { Text } = Typography;
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(undefined);
  const [detail, setDetail] = useState("");
  const [points, setPoints] = useState("");
  const [member, setMember] = useState({});
  const [error, setError] = useState("");
  const [loadList, setLoadList] = useState([]);

  const [query, setQuery] = useState("");
  const btnSubmitRef = useRef(null);
  const [source, setSource] = useState(axios.CancelToken.source());

  const selectSearchOnSelect = (i) => {
    const n = { ...loadList[+i] };
    const status = n.status?.toLowerCase();
    const is_staff = n.member_type?.toLowerCase() === "staff";

    setMember((prevBuyer) => {
      return {
        ...prevBuyer,
        member_id: n.member_id,
        partner_code: n.code,
        partner_name: `${n.first_name_th} ${n.sur_name_th}`,
        partner_mobile: n.mobile,
        partner_type: n.member_type_name,
        partner_type_code: n.member_type,
        team_name: n.team_name,
        allow_renew: n.allow_renew === 1,
        allow_item:
          is_staff || ["active", "pending", "waiting"].includes(status),
        is_married: n.is_married,
        is_freeze: n.is_freeze,
        rp_topup: n.rp_topup,
        text_suffix: n.text_suffix,
      };
    });
  };

  const selectSearchOnClick = () => {
    query && handleClickSearch();
  };

  const selectSearchCancelOnClick = () => {
    source.cancel("cancel search");
    setSource(axios.CancelToken.source());
  };

  const selectSearchOnChange = () => {
    if (btnSubmitRef.current) {
      btnSubmitRef.current.focus();
    }
  };

  const handleClickSearch = async () => {
    setLoading(true);

    setMember((prevBuyer) => {
      return {
        partner_document: prevBuyer.partner_document,
        partner_remark: prevBuyer.partner_remark,
      };
    });

    await axios({
      url: `${URL_API}/pos/master/member`,
      params: {
        type: "Member",
        query: query?.trim(),
      },
      cancelToken: source.token,
    })
      .then((res) => {
        setLoading(false);
        if (res.data.data && res.data.data.length > 0) {
          setLoadList(res.data.data);
        } else {
          notification.warning({
            message: "ไม่พบข้อมูล",
            description: "กรุณาตรวจสอบรหัสใหม่อีกครั้ง",
            placement: "bottomRight",
          });
        }
      })
      .catch((err) => {
        err.message !== "cancel search" && resCatch(err);
        setLoading(false);
      });
  };
  const selectSearchOnInputKeyDown = (e) => {
    let key = e.key;
    if (e.key === "Enter" && query) {
      handleClickSearch();
    }
    if (key === "Enter" && loadList.length === 0 && query) {
      handleClickSearch();
    } else if (key === "Backspace" || key === "Delete") {
      setQuery("");

      setLoadList([]);
    }
  };

  const selectSearchOnSearch = (e) => {
    if (e) {
      setQuery(e.trim());

      setLoadList([]);
    }
  };

  const resetAll = () => {
    setOptions([]);
    setLoading(false);
    setValue(undefined);
    setMember({});

    setQuery(""); 
    setLoadList([]); 
    setPoints("");
    setError("");
    setDetail("");
  };

  const handlePointsChange = (value) => {
    setPoints(value);

    if (!member) {
      setError("ยังไม่ได้เลือกสมาชิก");
    } else if (value > member.reward_balance) {
      setError(
        `RP พร้อมใช้ไม่เพียงพอ คะแนนสูงสุดที่ใช้ได้คือ ${Number(
          member.reward_balance
        ).toLocaleString()}`
      );
    } else if (value < 1 || value === null) {
      setError("กรอกคะแนนอย่างน้อย 1");
    } else {
      setError("");
    }
  };

  const handleSubmit = async () => {
    if (!member.partner_code) {
      notification.warning({
        message: "ไม่สามารถบันทึกได้",
        description: "กรุณาเลือกสมาชิกที่จะทำการจองคะแนน",
      });
      return;
    }

    if (!points || points < 1) {
      notification.warning({
        message: "ไม่สามารถบันทึกได้",
        description: "กรุณากรอกคะแนน",
      });
      return;
    }

    if (points > member.reward_balance) {
      notification.warning({
        message: "ไม่สามารถบันทึกได้",
        description: "คะแนนเกิน RP ที่ใช้งานได้",
      });
      return;
    }

    try {
      const pointValue = Number(points || 0);
      const payload = {
        partner_code: member.partner_code,
        partner_name: member.partner_name,
        detail: detail,
        points: pointValue,
      };

      const res = await axios({
        method: "post",
        baseURL: URL_API,
        url: `/point/rp/reserve-rp`,
        headers: { Authorization: "Bearer " + getToken() },
        data: payload,
        cancelToken: source.token,
      });

      if (res?.status === 200) {
        await notification.success({
          message: "สำเร็จ",
          description: res.data.message || "บันทึกการจองคะแนนสำเร็จ",
        });

        if (onSuccess) {
          onSuccess();
        } // reload list
        resetAll();
        onCancel();
      } else {
        notification.error({
          message: "ไม่สำเร็จ",
          description: res?.data?.message || "ไม่สามารถบันทึกข้อมูลได้",
        });
      }
    } catch (err) {
      notification.error({
        message: "บันทึกข้อมูลล้มเหลว",
        description: "กรุณาตรวจสอบรายการอีกรอบ",
      });
    }
  };
  return (
    <Modal
      title="เพิ่มการจองคะแนน"
      visible={visible}
      destroyOnClose
      onCancel={() => {
        resetAll();
        onCancel();
      }}
      footer={null}
      width={800}
    >
      <Row gutter={[16, 16]}>
        {/* ===== ช่องค้นหาสมาชิก ===== */}
        <Col span={24}>
          <SelectPartner
            placeholder={"ค้นหารหัสสมาชิก"}
            loadList={loadList}
            loading={loading}
            //disabled={loading}
            value={
              member?.partner_code
                ? member?.partner_code
                : query
                ? query
                : undefined
            }
            onClickSearch={selectSearchOnClick}
            onClickCancel={() => {
              selectSearchCancelOnClick();
            }}
            onChange={selectSearchOnChange}
            onInputKeyDown={selectSearchOnInputKeyDown}
            onSearch={selectSearchOnSearch}
            onSelect={(i) => {
              selectSearchOnSelect(i);
            }}
          />
        </Col>

        {/* ===== แสดงสมาชิก + RP ===== */}
        <Col span={24}>
          <Row align="middle">
            <Col span={18}>
              <b>สมาชิกผู้ดำเนินการ :</b>{" "}
              {member ? (
                <>
                  {member.partner_code ?? ""} {member.partner_name ?? ""}
                  {member.text_suffix && (
                    <Tag className="ml-2" color="magenta">
                      {member.text_suffix}
                    </Tag>
                  )}
                </>
              ) : (
                "ยังไม่ได้เลือก"
              )}
            </Col>

            <Col span={6} style={{ textAlign: "right" }}>
              <b>RP พร้อมใช้:</b>{" "}
              {member ? (
                <span style={{ color: "#00bfa5" }}>
                  {Number(member.rp_topup || 0).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </span>
              ) : (
                "-"
              )}
            </Col>
          </Row>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col>
          <Text strong>รายละเอียด :</Text>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col>
          <Input.TextArea
            disabled={!member?.partner_code}
            value={detail}
            maxLength={200}
            onChange={(e) => setDetail(e.target.value)}
            placeholder="ระบุรายละเอียดไม่เกิน 200 ตัวอักษร "
          />
          <div style={{ textAlign: "right", fontSize: "12px", color: "#999" }}>
            {detail?.length || 0} / 200
          </div>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col>
          <Text strong>คะแนนที่ใช้ :</Text>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <InputNumber
            disabled={!member?.partner_code}
            style={{ width: "100%" }}
            value={points}
            placeholder="ระบุคะแนนที่ต้องการจอง"
            min={1}
            step={1}
            precision={2}
            stringMode
            onChange={(value) => setPoints(value ?? "")}
            formatter={(value) =>
              value != null
                ? String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                : ""
            }
            parser={(value) =>
              value
                ?.replace(/,/g, "")
                .replace(/[^0-9.]/g, "")
                .replace(/(\..*)\./g, "$1")
            }
          />
        </Col>
        <Col span={24}>{error && <Text type="danger">{error}</Text>}</Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col
          span={24}
          style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}
        >
          <Button
            type="danger"
            ghost
            onClick={() => {
              resetAll();
              onCancel();
            }}
          >
            ยกเลิก
          </Button>
          <Button
            disabled={!member?.partner_code}
            type="primary"
            onClick={handleSubmit}
          >
            บันทึก
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default ReserveModal;
